module.exports = __webpack_public_path__ + "static/img/5.04f20a3.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/5.png
// module id = C0hq
// module chunks = 1